import { Component } from '@angular/core';

@Component({
  selector: 'app-rrhh-photo-example',
  templateUrl: './rrhh-photo-example.component.html',
  styleUrls: ['./rrhh-photo-example.component.scss'],
})
export class RrhhPhotoExampleComponent {}
